import { OrganizationProfile } from "@clerk/clerk-react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/organization")({
  component: () => (
    <div className="flex h-screen w-full flex-col items-center justify-center">
      <OrganizationProfile />
    </div>
  ),
});
